export default "__VITE_ASSET__RC71UYBA__"